module.exports = __webpack_public_path__ + "img/sass.88c10477.svg";